var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-dialog',{attrs:{"value":_vm.dialog,"width":420,"title":_vm.dialogTitle},on:{"input":_vm.onInput,"close":_vm.hide}},[_c('tutorial-list',{ref:"list",attrs:{"tutorials":_vm.tutorials,"selected":_vm.selected},on:{"select":function($event){_vm.selected = $event},"back":function($event){_vm.selected = null}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }